import $ from 'jquery';

export default function mNav () {
    $('body').addClass('js-ready');

	// get the button
	var button = $('#nav-open-btn, #nav-close-btn');
	button.on('click', toggleNav);

	// swipe to close nav - doesn't work on Android Chrome though
	// hacked quo script to exclude IE10 too cos quo doesn't support IE10
	if ('undefined' != typeof($$)) {
		$$('#nav-close-btn').swipeLeft(toggleNav);
	}

	function toggleNav(e) {
		e.preventDefault();
		$('html').toggleClass('js-nav');
	}
}
